import {
  BLUFI_FC_DIR_P2E,
  BLUFI_TYPE_CTRL,
  BLUFI_TYPE_CTRL_SUBTYPE_CONN_TO_AP,
  BLUFI_TYPE_CTRL_SUBTYPE_DISCONN_FROM_AP,
  BLUFI_TYPE_CTRL_SUBTYPE_GET_WIFI_LIST,
  BLUFI_TYPE_CTRL_SUBTYPE_GET_WIFI_STATUS,
  BLUFI_TYPE_CTRL_SUBTYPE_SET_WIFI_OPMODE,
  BLUFI_TYPE_DATA,
  BLUFI_TYPE_DATA_SUBTYPE_CUSTOM_DATA,
  BLUFI_TYPE_DATA_SUBTYPE_STA_PASSWD,
  BLUFI_TYPE_DATA_SUBTYPE_STA_SSID,
  WIFI_MODE_STA,
} from "@/services/blufi-constants.ts";
import {
  BleClient,
  numbersToDataView,
  numberToUUID,
} from "@capacitor-community/bluetooth-le";
import { ref } from "vue";

const BLUFI_SERVICE = numberToUUID(0xffff);
const BLUFI_RD_CHARACTERISTIC = numberToUUID(0xff02); // Readable and callable
const BLUFI_WR_CHARACTERISTIC = numberToUUID(0xff01); // Writable

const sequences = ref<Record<string, number>>({});

export const sendCommand = async (deviceId: string, url: string, data: any) => {
  const command = JSON.stringify({ ...data, command: `php${url}` });
  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_DATA,
    BLUFI_TYPE_DATA_SUBTYPE_CUSTOM_DATA,
    command
  );
};

export const sendGetWifiList = async (deviceId: string) => {
  console.log("sendGetWifiList");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_CTRL,
    BLUFI_TYPE_CTRL_SUBTYPE_SET_WIFI_OPMODE,
    WIFI_MODE_STA
  );

  console.log("sendGetWifiList: setWifiOpmode done");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_CTRL,
    BLUFI_TYPE_CTRL_SUBTYPE_GET_WIFI_LIST
  );

  console.log("sendGetWifiList: getWifiList done");
};

export const sendGetWifiStatus = (deviceId: string) => {
  return sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_CTRL,
    BLUFI_TYPE_CTRL_SUBTYPE_GET_WIFI_STATUS
  );
};

export const setWifi = async (
  deviceId: string,
  { ssid, password }: { ssid: string; password: string }
) => {
  console.log("setWifi");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_CTRL,
    BLUFI_TYPE_CTRL_SUBTYPE_SET_WIFI_OPMODE,
    WIFI_MODE_STA
  );

  console.log("setWifi: setWifiOpmode done");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_DATA,
    BLUFI_TYPE_DATA_SUBTYPE_STA_SSID,
    ssid
  );

  console.log("setWifi: setSSID done");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_DATA,
    BLUFI_TYPE_DATA_SUBTYPE_STA_PASSWD,
    password
  );

  console.log("setWifi: setPassword done");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_CTRL,
    BLUFI_TYPE_CTRL_SUBTYPE_CONN_TO_AP
  );

  console.log("setWifi: connect done");
};

export const clearWifi = async (deviceId: string) => {
  console.log("ClearWifi");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_DATA,
    BLUFI_TYPE_DATA_SUBTYPE_STA_SSID,
    ""
  );

  console.log("ClearWifi: setSSID done");

  await sendBlufiFrame(
    deviceId,
    BLUFI_TYPE_CTRL,
    BLUFI_TYPE_CTRL_SUBTYPE_DISCONN_FROM_AP
  );

  console.log("ClearWifi: disconnect done");
};

const sendBlufiFrame = async (
  deviceId: string,
  type: number,
  subType: number,
  data?: string | number
) => {
  const frameType = (subType << 2) + type;
  const frameControl = BLUFI_FC_DIR_P2E;
  const frameSequence = sequences.value[deviceId] ?? 0;
  const frameLength =
    data === undefined ? 0 : typeof data === "string" ? data.length : 1;

  const payload = [frameType, frameControl, frameSequence, frameLength];

  if (typeof data === "string") {
    for (let i = 0; i < data.length; i++) {
      payload.push(data.charCodeAt(i));
    }
  } else if (typeof data === "number") {
    payload.push(data);
  }

  sequences.value[deviceId] = frameSequence + 1;
  await BleClient.write(
    deviceId,
    BLUFI_SERVICE,
    BLUFI_WR_CHARACTERISTIC,
    numbersToDataView(payload)
  );

  console.log(
    `sendBlufiFrame (deviceId=${deviceId}, frameType=${frameType}, frameSequence=${frameSequence}, frameLength=${frameLength}, data=${data})`
  );
};

export const resetSequences = () => {
  console.log("Resetting sequences");
  sequences.value = {};
};
